<template>
  <b-card class="mt-1">
    <h5 class="font-weight-bolder mb-1">Bet Placed Alert</h5>

    <div v-if="loading" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>

    <div v-else>
      <div class="mb-1">
        <div class="d-flex align-items-center justify-content-between mb-50">
          <span class="font-weight-bold">Enabled</span>
          <b-form-checkbox v-model="form.enabled" switch />
        </div>
        <b-form-group
          label="Liability Threshold"
          label-for="bet-placed-alert-liability-threshold"
        >
          <b-form-input
            id="bet-placed-alert-liability-threshold"
            v-model.number="form.liabilityThreshold"
            type="number"
            min="0"
            :disabled="!form.enabled"
          />
        </b-form-group>
      </div>

      <b-button variant="primary" :disabled="saving" @click="handleSave">
        <b-spinner v-if="saving" small class="mr-50" />
        <feather-icon v-else icon="SaveIcon" />
        Save Changes
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BSpinner,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import useToastHandler from "@/services/toastHandler";

export default {
  components: {
    BCard,
    BSpinner,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
  },
  setup() {
    const { showToastSuccess } = useToastHandler();
    return { showToastSuccess };
  },
  data() {
    return {
      form: {
        enabled: false,
        liabilityThreshold: 0,
      },
    };
  },
  computed: {
    ...mapState("settings/bet-placed-alert-config", ["loading", "saving"]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions("settings/bet-placed-alert-config", [
      "getBetPlacedAlertConfig",
      "updateBetPlacedAlertConfig",
    ]),
    async fetchData() {
      const data = await this.getBetPlacedAlertConfig();
      const val = data?.value || {};
      this.form = {
        enabled: val.enabled ?? false,
        liabilityThreshold: val.liabilityThreshold ?? 0,
      };
    },
    async handleSave() {
      const result = await this.updateBetPlacedAlertConfig({
        enabled: this.form.enabled,
        liabilityThreshold: Number(this.form.liabilityThreshold) || 0,
      });
      if (result) {
        this.showToastSuccess("Bet Placed Alert", "Saved successfully");
      }
    },
  },
};
</script>
